import gql from 'graphql-tag'
import { session } from "./fragments.js";

export const beginSurvey = gql`
  mutation beginSession($school_code: String!, $language: String) {
      beginSession(input: { school_code: $school_code, language: $language }) {
        ...Session
      }
  }
  ${session}
`

export const answerQuestion = gql`
  mutation answerQuestion($input: UserResponse!) {
    answerQuestion(input: $input) {
      id
      selected_answer
    }
  }
`

export const setLanguage = gql`
  mutation setLanguage($session_id: String!, $language_code: String!) {
    setLanguage(session_id: $session_id, language_code: $language_code) {
      ...Session
    }
  }
  ${session}
`

export const submitFeedback = gql`
  mutation submitFeedback($session_id: ID!, $feedback: String!, $contact: String) {
    submitFeedback(input: { 
      session_id: $session_id, 
      text: $feedback, 
      contact: $contact })
  }
`

export const notifyResults = gql`
  mutation notifyResults($session_id: ID!, $email: String!) {
    notifyResults(input: {
      session_id: $session_id,
      email: $email
    })
  }
`


// WEBPACK FOOTER //
// ./src/graphql/mutations.js